import { ApolloClient, from, InMemoryCache } from '@apollo/client'
import { httpLink, requestIDLink, retryLink } from 'utils/apollo'

export const authClient = new ApolloClient({
  link: from([requestIDLink, retryLink, httpLink]),
  cache: new InMemoryCache(),
  ssrMode: false,
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all'
    },
    query: {
      errorPolicy: 'all'
    }
  }
})
